import React from 'react';

import Tooltip from '../Tooltip/Tooltip';

import styles from './ReferAccessButtonTooltip.module.scss';

/**
 * Wraps refer buttons so tooltips still work when the button is disabled.
 * Native title attributes do not show on disabled elements in most browsers.
 */
const ReferAccessButtonTooltip = ({ blocked, tooltipText, children, placement = 'top' }) => {
  if (!blocked || !tooltipText) {
    return children;
  }

  return (
    <Tooltip text={tooltipText} placement={placement} id="referral-access-tooltip">
      <span className={styles.wrapper}>{children}</span>
    </Tooltip>
  );
};

export default ReferAccessButtonTooltip;
